import React from "react";
import { Type } from "discover.medical.react-component-library";

const ExcludedContentMessage = ({ message }) => {
  return (
    <Type color="error" element="i" fontSize="sm">
      {message}
    </Type>
  );
};

export default ExcludedContentMessage;
